var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Combobox, Text, useFilter, useListCollection, useSlotRecipe, visuallyHiddenStyle, } from "@chakra-ui/react";
import { useEffect, useMemo } from "react";
function uniqueOptions(options) {
    var seenValues = new Set();
    return options.filter(function (option) {
        if (!option.value || !option.label || seenValues.has(option.value)) {
            return false;
        }
        seenValues.add(option.value);
        return true;
    });
}
export function JobFilterMultiSelect(_a) {
    var label = _a.label, name = _a.name, options = _a.options, value = _a.value, onValueChange = _a.onValueChange, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.placeholder, placeholder = _c === void 0 ? label : _c, _d = _a.emptyText, emptyText = _d === void 0 ? "No options found" : _d;
    var recipe = useSlotRecipe({ key: "JobFilterMultiSelect" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var normalizedOptions = useMemo(function () { return uniqueOptions(options); }, [options]);
    var contains = useFilter({ sensitivity: "base" }).contains;
    var _e = useListCollection({
        initialItems: normalizedOptions,
        itemToString: function (option) { return option.label; },
        itemToValue: function (option) { return option.value; },
        filter: contains,
    }), collection = _e.collection, filter = _e.filter, set = _e.set;
    useEffect(function () {
        set(normalizedOptions);
    }, [normalizedOptions, set]);
    return (_jsx(Box, __assign({ css: styles.root }, { children: _jsxs(Combobox.Root, __assign({ collection: collection, multiple: true, value: value, onValueChange: function (details) {
                return onValueChange(details.value);
            }, onInputValueChange: function (details) {
                return filter(details.inputValue);
            }, openOnClick: true, positioning: { sameWidth: true } }, { children: [_jsx(Combobox.Label, __assign({ css: visuallyHiddenStyle }, { children: label })), _jsxs(Combobox.Control, __assign({ css: styles.control }, { children: [_jsx(Combobox.Input, { css: styles.input, name: name, placeholder: loading
                                ? "Loading ".concat(label.toLowerCase(), "...")
                                : value.length > 0
                                    ? "".concat(placeholder, " (").concat(value.length, " selected)")
                                    : placeholder, autoComplete: "off" }), _jsx(Combobox.IndicatorGroup, { children: _jsx(Combobox.Trigger, { "aria-label": "Show ".concat(label, " options") }) })] })), _jsx(Combobox.Positioner, { children: _jsxs(Combobox.Content, __assign({ css: styles.content }, { children: [_jsx(Combobox.Empty, { children: _jsx(Text, __assign({ css: styles.empty }, { children: loading ? "Loading..." : emptyText })) }), collection.items.map(function (option) { return (_jsxs(Combobox.Item, __assign({ css: styles.item, item: option }, { children: [_jsx(Combobox.ItemText, { children: option.label }), _jsx(Combobox.ItemIndicator, {})] }), option.value)); })] })) })] })) })));
}
